// 字典管理接口
import http from "@/promise/http"
const CONTROLLER_NAME = "/dict/"

export const postDictCode = code => {
    return http.post(CONTROLLER_NAME.concat("getDictData"), { code: code });
};



